import { Link, useNavigate } from "react-router-dom";
import TranslateWidget from "./TranslateWidget";

// Shared mobile app bar: centered Cars53 logo, optional back button (left)
// and an optional right-side slot (avatar, action, etc.).
// `back` may be a path string (Link) or a number to move through history
// (e.g. -1 = previous screen).
const MobileHeader = ({ back, right }) => {
    const navigate = useNavigate();
    const isHistory = typeof back === "number";
    return (
        <div className="mlux-appbar" data-rise="1">
            {back != null && (
                isHistory ? (
                    <button type="button" onClick={() => navigate(back)} className="mlux-back-btn" aria-label="Back">
                        <i className="fas fa-arrow-left"></i>
                    </button>
                ) : (
                    <Link to={typeof back === "string" ? back : "/"} className="mlux-back-btn" aria-label="Back">
                        <i className="fas fa-arrow-left"></i>
                    </Link>
                )
            )}
            <Link to="/" className="mlux-applogo-link">
                <img src="/assets/img/logo/logo.png" alt="Cars53" className="mlux-applogo" />
            </Link>
            <div className="mlux-appbar-right">
                <TranslateWidget />
                {right}
            </div>
        </div>
    );
};

export default MobileHeader;
